import { getAppRuntimeConstants, getLoggedInUser, logUserActivity, updateDownloadLinksWithVersion } from './utils'

window.onload = () => {

    try {
        const user = getLoggedInUser()
        if (user) {
            logUserActivity('VIEW_DOWNLOAD_APP', user.username, user)
        } else {
            logUserActivity('GUEST_VIEW_DOWNLOAD_APP')
        }
    } catch (error) {
        console.error('Error in Analytics:', error)
    }

    $('.download-button').on('click', function(event) {    
        const downloadUrl = $(this).attr('href');
        
        let platform;
        switch (true) {
            case $(this).hasClass('windows'):
                platform = 'Windows';
                break;
            case $(this).hasClass('mac-button'):
                platform = 'Mac';
                break;
            default:
                platform = 'Unknown';
                break;
        }
    
        const eventData = {
          url: downloadUrl,
          platform: platform
        };
    
        try {
          const user = getLoggedInUser();
          if (user) {
            logUserActivity('DOWNLOAD_CLICKED', user.username, { eventData, user })
          } else {
            logUserActivity('GUEST_DOWNLOAD_CLICKED', '', { eventData })
          }
        } catch (error) {
          console.error('Error logging download click analytics:', error)
        }
    })

    $('#spark-version').innerText = 'Spark version ';
    getAppRuntimeConstants()
    .then(response => {
        const { app_latest_version, spark_latest_version } = response
        $('#spark-version').innerText = 'Spark version ' + spark_latest_version;

        updateDownloadLinksWithVersion(app_latest_version, spark_latest_version)
    })

    $('#error-message').remove()
    $('#error-message-spark').remove()

    // Send download-app-email request to the API on clicking the SUBMIT button.
    let isSending = false
    $('#edit-account-btn').on('click', (ev) => {
        ev.preventDefault()

        $('#error-text').css('display', 'none')

        function disableButton() {
            $('#edit-account-btn')
                .css('pointer-events', 'none')
                .css('opacity', '0.75')
            isSending = true
        }
        function enableButton() {
            $('#edit-account-btn')
                .css('pointer-events', 'auto')
                .css('opacity', '1')
            isSending = false
        }
        function removeButton() {
            $('#edit-account-btn').css('display', 'none')
        }

        const email = $('#email-signup').val()

        // disable button from further clicks
        disableButton()

        console.log(`POST`)
        if ((email||'').trim().length === 0) {
            alert(`Please specify an email.`)
            enableButton()
            return
        }

        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/requests/download-app-email`,
            data: JSON.stringify({ email: email }),
            dataType: 'json',
            contentType: 'application/json',
            error: response => {
                alert(`Sorry, there was an error while processing the request.`)
                enableButton()
            },
            success: response => {
                $('#success-message').css('display', 'block')
                $('#success-message > div').css('color', '#161616')
                removeButton()
            },
        })
    })

    document.getElementById('email-form-spark').addEventListener('submit', function(event) {
        event.preventDefault();

        function disableButton() {
            $('#email-form-spark #edit-account-btn')
                .css('pointer-events', 'none')
                .css('opacity', '0.75')
            isSending = true
        }
        function enableButton() {
            $('#email-form-spark #edit-account-btn')
                .css('pointer-events', 'auto')
                .css('opacity', '1')
            isSending = false
        }
        function removeButton() {
            $('#email-form-spark #edit-account-btn').css('display', 'none')
        }

        const email = $('#email-signup-spark').val()

        // disable button from further clicks
        disableButton()

        console.log(`POST`)
        if ((email||'').trim().length === 0) {
            alert(`Please specify an email.`)
            enableButton()
            return
        }

        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/requests/download-app-email`,
            data: JSON.stringify({ email: email }),
            dataType: 'json',
            contentType: 'application/json',
            error: response => {
                alert(`Sorry, there was an error while processing the request.`)
                enableButton()
            },
            success: response => {
                $('#success-message-spark').css('display', 'block')
                $('#success-message-spark > div').css('color', '#161616')
                removeButton()
            },
        })
    })
}
